// const store = require("../store");
import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import appConfig from "../appConfig";
import accountService from "./accountService";
import Store from "../store";
// import hash from "hash.js";
import MD5 from 'md5.js';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: appConfig.ApplicationInsights.InstrumentationKey
    /* ...Other Configuration Options... */
  }
});
appInsights.loadAppInsights();

const store = new Store();

var LoggerService = {};
/**
 * メッセージをApplication Insightsに送信します。
 * @param {String} message
 * @param {Map} properties
 */
LoggerService.info = function(message, properties) {
    // appInsights.trackTrace(message, properties, severityLevel);
    appInsights.trackTrace({message, properties, severityLevel: SeverityLevel.Information});
}

/**
 * 例外をApplication Insightsに送信します。
 * @param {Object} error
 * @param {string} errorCode
 */
LoggerService.error = function(error, errorCode) {
  appInsights.trackException({
    exception: error,
    properties: {
      tenant: store.tenant ? store.tenant.id : "",
      errorCode
    }
  });
}

/**
 * ページ情報をApplication Insightsに送信します。
 * @param {String} pageName
 * @param {Map} properties
 */
LoggerService.pageView = function(pageName, properties) {
  const isLoggedIn = accountService.isLogedin();
  // アカウントをmd5してトレース可能にする(shaにするほどではないので)
  const md5account = isLoggedIn && store.account ? new MD5().update(store.account).digest('hex') : "";
  const tenantId = isLoggedIn && store.tenant ? store.tenant.id : "";
  const props = Object.assign({
    type: 'PC', // PC版と識別できるように情報追加
    name: pageName,
    account: md5account,
    tenant: tenantId,
    // browser info
    referrer: document.referrer,
    width: screen.width,
    height: screen.height,
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  }, properties ? properties : {});
  appInsights.trackPageView({
    name: pageName,
    url: location.href,
    isLoggedIn,
    properties: props
  })
}

export default LoggerService;
